import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import * as serviceWorker from './serviceWorkerRegistration';

const Snackbar = ({open, message, onClick, action}) => {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed',
        width: '100%',
        zIndex: '1000',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        margin: 'auto',
        top: '0',
        direction: 'rtl',
        fontFamily: 'IRANYekan',
      }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
          backgroundColor: 'rgb(185, 22, 24)',
          padding: '10px',
          color: 'white',
          borderRadius: '5px',
          boxSizing: 'border-box',
          margin: '10px',
          minWidth: '365px',
        }}
        onClick={onClick}>
        <div
          style={{
            width: '90%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexFlow: 'row',
          }}
          onClick={onClick}>
          {message} {action}
        </div>
      </div>
    </div>
  );
};

const ServiceWorkerWrapper = () => {
  const {t} = useTranslation();
  const [showReload, setShowReload] = React.useState(false);
  const [waitingWorker, setWaitingWorker] = React.useState(null);

  const onSWUpdate = registration => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    serviceWorker.register({onUpdate: onSWUpdate});
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({type: 'SKIP_WAITING'});
    setShowReload(false);
    window.location.reload(true);
  };

  return (
    <Snackbar
      open={false}
      message={t('new_version_available')}
      onClick={reloadPage}
      action={
        <button
          style={{
            fontFamily: 'IRANYekan',
            padding: '6px',
            borderRadius: '5px',
            border: '1px solid white',
            backgroundColor: 'white',
            cursor: 'pointer',
          }}
          onClick={reloadPage}>
          {t('update')}
        </button>
      }
    />
  );
};

export default ServiceWorkerWrapper;
